import { api } from "./api";

export const getMySessionsApi = () => api.get('/session/my');
export const terminateSessionApi = (id) => api.delete(`/session/${id}`);
export const terminateOtherSessionsApi = () => api.delete('/session/others');

export const adminGetUserSessionsApi = (userId) => api.get(`/admin/users/${userId}/sessions`);
export const adminGetUserSessionHistoryApi = (userId, page = 1) => api.get(`/admin/users/${userId}/sessions/history?page=${page}`);
export const adminTerminateSessionApi = (userId, id) => api.delete(`/admin/users/${userId}/sessions/${id}`);
export const adminTerminateAllSessionsApi = (userId) => api.delete(`/admin/users/${userId}/sessions/all`);
